import { render, staticRenderFns } from "./VSwitch.vue?vue&type=template&id=2357353b&scoped=true"
import script from "./VSwitch.vue?vue&type=script&lang=js"
export * from "./VSwitch.vue?vue&type=script&lang=js"
import style0 from "./VSwitch.vue?vue&type=style&index=0&id=2357353b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2357353b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2718431902/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2357353b')) {
      api.createRecord('2357353b', component.options)
    } else {
      api.reload('2357353b', component.options)
    }
    module.hot.accept("./VSwitch.vue?vue&type=template&id=2357353b&scoped=true", function () {
      api.rerender('2357353b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/volta/VSwitch.vue"
export default component.exports